// Данные партнерских федераций с взаимным признанием
// SUMA International имеет соглашения о взаимном признании с этими организациями

export const partnerFederations = [
  {
    id: 1,
    nameRu: 'Международная федерация Jugo Kobute и Kempo Ryu',
    nameEn: 'International Jugo Kobute and Kempo Ryu Federation',
    nameJa: '国際柔術小武手・拳法流連盟',
    descriptionRu: 'Международная федерация Jugo Kobute и Kempo Ryu',
    descriptionEn: 'International Jugo Kobute and Kempo Ryu Federation',
    descriptionJa: '国際柔術小武手・拳法流連盟',
    logo: '/images/partner-federations/international-jugo-kobute-kempo-ryu-federation.png',
    website: null
  },
  {
    id: 2,
    nameRu: 'Международная ассоциация боевого айкидо',
    nameEn: 'International Combat Aikido Association',
    nameJa: '国際コンバット合気道協会',
    descriptionRu: 'Международная ассоциация боевого айкидо',
    descriptionEn: 'International Combat Aikido Association',
    descriptionJa: '国際コンバット合気道協会',
    logo: '/images/partner-federations/International-Combat-Aikido-Association.png',
    website: null
  },
  {
    id: 3,
    nameRu: 'Всемирный союз Кемпо Кай',
    nameEn: 'World Kempo Kai Union',
    nameJa: '世界拳法会連合',
    descriptionRu: 'Всемирный союз Кемпо Кай',
    descriptionEn: 'World Kempo Kai Union',
    descriptionJa: '世界拳法会連合',
    logo: '/images/partner-federations/World-Kempo-Kai-Union.png',
    website: null
  }
]

// Функция для получения локализованных данных партнерских федераций
export const getLocalizedPartnerFederations = (language) => {
  const isJapanese = language === 'ja'
  const isRussian = language === 'ru'
  
  return partnerFederations.map(federation => ({
    ...federation,
    name: isJapanese ? (federation.nameJa || federation.nameEn) : (isRussian ? federation.nameRu : federation.nameEn),
    description: isJapanese ? (federation.descriptionJa || federation.descriptionEn) : (isRussian ? federation.descriptionRu : federation.descriptionEn)
  }))
}

